<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
        :visibleSearch="false"
        :visiblePagination="visiblePagination"
    ></CTable>
    <CTable
        v-if="viewOnlyInspection === undefined && storageLocations.length !== 0"
        :isLoading="isLoading"
        :columns="sumColumns"
        :page="sumPage"
        :clientSide="true"
        :canRefresh="false"
        :visibleSearch="false"
        :visiblePagination="false"
    ></CTable>
    <div class="has-error" v-if="data.useForm.validateInfos[`${itemsKey}`]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm.validateInfos[`${itemsKey}`]?.help }}
        </div>
    </div>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { state as stateApp } from "../../../../../app.logic";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import { initData, isLoading } from "./inform-product-qty.logic";
import lodash from "lodash";
import { createPage } from "../../../../../utils/page";
import { formatInputValue } from "../../../../../components/input/template-builder/input-number/input-number.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        viewOnlyInspection: {},
        isCombineQty: {},
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        canCreate: {},
        canDelete: {},
        request: {},
        inform: {},
        initInform: {},
        informProduct: {},
        initInformProduct: {},
        informProducts: {},
        initInformProducts: {},
        hazLicense: {},
        storageLocations: {},
        balanceOnly: { default: false },
        visiblePagination: { default: true },
        showStorageLocation: { default: false },
        showLot: { default: false }
    },
    setup(props) {
        const i18n = useI18n();
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        const sumColumns = computed(() => [
            createColumnInput({
                title: () => "",
                dataIndex: "sum",
                customRender: () => <div>{i18n.t("views.request.informProductQty.sum")}</div>,
                align: "center",
                sorter: false,
                search: { visible: () => false }
            }),
            ...lodash
                .cloneDeep(data.columns)
                .filter(d => !["refStorageLocation", "refStorageLocationSub", 'refStorageLocationSubItem'].includes(d.dataIndex))
                .map(d => {
                    d.customRender = ({ text }) => text;
                    d.sorter = false;
                    return d;
                })
        ]);
        const sumPage = computed(() => {
            const { itemsKey } = props;
            const { useForm } = data;
            const { modelRef } = useForm;
            const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
            return createPage({
                data: [
                    {
                        /*
                        qty: formatInputValue({
                            props: {
                                comma: true,
                                allowPrecision: true,
                                maxPrecision: 2,
                                value: items
                                    .map(item => item.qty)
                                    .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0)
                            },
                            data: { focus: false }
                        }),
                        */
                        refQtyUnit: items?.[0]?.refQtyUnit?.value,
                        netWeight: formatInputValue({
                            props: {
                                comma: true,
                                allowPrecision: true,
                                maxPrecision: 2,
                                value: items
                                    .map(item => item.netWeight)
                                    .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0)
                            },
                            data: { focus: false }
                        }),
                        refNetWeightUnit: items?.[0]?.refNetWeightUnit?.value,
                        // refPackagingCharacteristic: items?.[0]?.refPackagingCharacteristic?.value,
                        /*
                        numberOfPackage: formatInputValue({
                            props: {
                                comma: true,
                                allowPrecision: true,
                                maxPrecision: 2,
                                value: items
                                    .map(item => item.numberOfPackage)
                                    .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0)
                            },
                            data: { focus: false }
                        }),
                        packageSize: formatInputValue({
                            props: {
                                comma: true,
                                allowPrecision: true,
                                maxPrecision: 2,
                                value: items
                                    .map(item => item.packageSize)
                                    .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0)
                            },
                            data: { focus: false }
                        }),
                        */
                        refPackageUnit: items?.[0]?.refPackageUnit?.value,
                        amount: formatInputValue({
                            props: {
                                comma: true,
                                allowPrecision: true,
                                maxPrecision: 2,
                                value: items
                                    .map(item => item.amount)
                                    .reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0)
                            },
                            data: { focus: false }
                        })
                    }
                ]
            });
        });
        return { props, data, refs, isLoading, sumColumns, sumPage };
    }
});
</script>
